import { render, staticRenderFns } from "./customer-manage.vue?vue&type=template&id=117a0561&scoped=true"
import script from "./customer-manage.vue?vue&type=script&lang=js"
export * from "./customer-manage.vue?vue&type=script&lang=js"
import style0 from "./customer-manage.vue?vue&type=style&index=0&id=117a0561&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "117a0561",
  null
  
)

export default component.exports